/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
/**
 * This represents different user types supported in PAM.
 **/
export var UserType;
(function (UserType) {
    UserType["PRINCIPAL"] = "PRINCIPAL";
    UserType["LDAP"] = "LDAP";
    UserType["POSIX"] = "POSIX";
    UserType["TEAM"] = "TEAM";
    UserType["EXTERNAL"] = "EXTERNAL";
})(UserType || (UserType = {}));
